//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import {
  IGallery,
  ISelfServeGallery,
} from '@apis/galleries/galleriesApiModels';
import { ExperienceContainerType } from '@models/ExperienceContainerType';
import { isSelfServeGallery } from './galleryTypeUtils';

// Returns true if the gallery is an InstaShop gallery, false otherwise

export const isInstaShopGallery = (
  gallery: IGallery,
): gallery is ISelfServeGallery => {
  return (
    isSelfServeGallery(gallery) &&
    gallery.containerType === ExperienceContainerType.INSTASHOP
  );
};
